import { useEffect } from "react";

export const useEditorMountBootstrap = ({
  showToastRef,
  state,
  setIsOneTimeAsset,
  setOpenModulesModal,
  setOpenModulesScreen,
  observeMutations,
}) => {
  useEffect(() => {
    showToastRef.current = true;
    if (state?.editClicked || state?.newBanner) {
      if (typeof state?.onetimeBanner === "boolean") {
        const routeOneTime = state.onetimeBanner;
        window.localStorage.setItem(
          "oneTimeAsset",
          JSON.stringify(routeOneTime),
        );
        setIsOneTimeAsset(routeOneTime);
      }
    }
    if (state?.newBanner) {
      setOpenModulesModal(true);
      setOpenModulesScreen(true);
    }
    observeMutations();
  }, []);
};
